import history from '../../../helpers/history'
import { useErrorHandler } from "react-error-boundary";
import { INextLoanRepayment } from "../../../interfaces/metrics";
import { FC } from "react";

type Props = {
  error: Error | null;
  fetching: boolean;
  nextLoanRepayment: INextLoanRepayment[];
};

const NextRepayment: FC<Props> = ({ error, fetching, nextLoanRepayment }) => {
  useErrorHandler(error);

  const onClick = () => {
    history.push(`/loan/${nextLoanRepayment[0]?.loan_id}/information`);
  };

  const buttonDisabled = nextLoanRepayment.length < 1;

  return (
    <div className="card bg-success hoverable card-xl-stretch mb-5 mb-xl-8">
      <div className="card-body">
        <div className="fw-bold text-inverse-success fs-7 mb-2 text-center">
          Your Next Repayment
        </div>
        <h1 className="text-white fs-0 fw-700 mt-5 mb-5 text-center">
          <i className="menu-icon bi fs-1 bi-credit-card-2-front text-white"></i>{" "}
          {fetching
            ? "--"
            : nextLoanRepayment.length < 1
            ? "N/A"
            : `₦${parseFloat(nextLoanRepayment[0]?.amount).toLocaleString()}`}
        </h1>
        <div className="fw-bold text-inverse-success fs-7 text-center">
          <button
            onClick={onClick}
            disabled={buttonDisabled}
            className="btn btn-warning btn-sm"
          >
            <span className="fw-bolder">Pay Now</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NextRepayment;
